import { SubmitHandler, UseFormReturn } from "react-hook-form";
import { useTranslation } from "react-i18next";

import { ButtonLink, SubmitButton } from "@/components/Interface/Button/Button";
import { ProfileCard } from "@/components/Layout/BaseLayouts/ProfileCard/ProfileCard";
import { NumberForm } from "@/hooks/useNumberForm";

import {
  stepDescriptionClassName,
  stepHeadingClassName,
} from "./authenticator.utils";
import { AuthenticatorPhoneNumberField } from "./AuthenticatorPhoneNumberField";

export const AuthenticatorSmsSetupForm = ({
  formMethods,
  onSubmit,
}: {
  formMethods: UseFormReturn<NumberForm, any, NumberForm>;
  onSubmit: SubmitHandler<NumberForm>;
}) => {
  const { t } = useTranslation();

  return (
    <form onSubmit={formMethods.handleSubmit(onSubmit)}>
      <ProfileCard
        maxWidth="none"
        title={t("portal:user-account.security.2fa.initialSetup.title")}
        actions={
          <>
            <ButtonLink variant="secondary" size="sm" to={-1 as any}>
              {t("portal:user-account.security.buttons.cancel")}
            </ButtonLink>
            <SubmitButton
              fullWidth={false}
              size="sm"
              label={t("portal:authenticator.sms.enterNumber.sendCode")}
            />
          </>
        }
      >
        <div className="flex flex-col gap-4">
          <h2 className={stepHeadingClassName}>
            {t("portal:authenticator.sms.enterNumber.title")}
          </h2>
          <p className={stepDescriptionClassName}>
            {t("portal:authenticator.sms.enterNumber.description")}
          </p>
          <AuthenticatorPhoneNumberField
            register={formMethods.register}
            errors={formMethods.formState.errors}
          />
        </div>
      </ProfileCard>
    </form>
  );
};
